const DEFAULT_ITEMS_PER_PAGE = 9;
const DEFAULT_LOADING_TIME = 500;
const INITIAL_PAGE = 1;

export {DEFAULT_ITEMS_PER_PAGE, DEFAULT_LOADING_TIME, INITIAL_PAGE};
